export default class MvParallax {
    constructor() {
        this.layers = [
            { els: document.querySelectorAll(".js-mv-ph"), strength: 12 },
            { els: document.querySelectorAll(".js-mv-year"), strength: 8 },
            { els: document.querySelectorAll(".js-mv-floor"), strength: 4 },
        ].filter((layer) => layer.els.length);

        // SPでは動かさない
        this.enabled = window.matchMedia("(pointer: fine)").matches;
        if (!this.enabled) return;

        this.ease = 0.08;
        this.target = { x: 0, y: 0 };
        this.current = { x: 0, y: 0 };

        this.onMove = this.onMove.bind(this);
        this.render = this.render.bind(this);

        // this.init();
    }

    init() {
        window.addEventListener("mousemove", this.onMove);
        requestAnimationFrame(this.render);
    }

    onMove(e) {
        //画面中心を0、-1～1の範囲で座標を取得
        this.target.x = (e.clientX / window.innerWidth) * 2 - 1;
        this.target.y = (e.clientY / window.innerHeight) * 2 - 1;
    }

    render() {
        this.current.x += (this.target.x - this.current.x) * this.ease;
        this.current.y += (this.target.y - this.current.y) * this.ease;

        for (const layer of this.layers) {
            //マウスと逆方向に動かす
            const x = -this.current.x * layer.strength;
            const y = -this.current.y * layer.strength;
            for (const el of layer.els) {
                el.style.setProperty("--mx", `${x.toFixed(2)}px`);
                el.style.setProperty("--my", `${y.toFixed(2)}px`);
            }
        }

        requestAnimationFrame(this.render);
    }
}
